export default class Image {
    static getBase64(url) {
        return new Promise((resolve, reject) => {
            fetch(url)
                .then((data) => {
                    if (!data.ok) throw new Error(`Image request failed with status ${data.status}: ${url}`);
                    return data.blob();
                })
                .then((blob) => {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = () => {
                        reject(reader.error || new Error(`Could not read image: ${url}`));
                    };
                    reader.readAsDataURL(blob);
                })
                .catch((error) => {
                    reject(error instanceof Error ? error : new Error(`Could not load image: ${url}`));
                });
        });
    };
}
